import React, { Component } from 'react';
import { ApplicationFormShell } from 'web-ui-components/lib/layout/shells';
import { DisputeProgressComponent } from './DisputeProgressComponent';
import { PageHeading } from 'web-ui-components/lib/typography/headings';
import { StandardBody } from 'web-ui-components/lib/typography/body';
import { NavigationButton } from 'web-ui-components/lib/navigation/buttons';
import {
  DateOfBirthInput,
  GenericTextArea,
} from 'web-ui-components/lib/data/capture';
import { GenericFieldWrapper } from 'web-ui-components/lib/layout/fieldWrappers';
import FraudAndDisputeActionCreator from '../../../actions/FraudAndDisputeActionCreator';
import FraudAndDisputeStore from '../../../stores/FraudAndDisputeStore';
import {
  PAGE_DESCRIBE_THE_GOODS,
  PAGE_DESCRIBE_THE_TRAVEL_BOOKING,
  DESCRIPTION_TEXT_MAXIMUM_CHARACTERS_LENGTH,
  DESCRIPTION_TEXT_MINIMUM_CHARACTERS_LENGTH,
  PAGE_REVIEW_YOUR_DISPUTE,
  PAGE_DESCRIBE_THE_SERVICE,
} from '../../../constants/FraudAndDisputeConstants';
import moment from 'moment';
import AnalyticsUtil from '../../../utils/AnalyticsUtil';
import config from '../../../config';

export class WhatHappened extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sellerContactDate: FraudAndDisputeStore.getSellerContactDate(),
      descriptionText: FraudAndDisputeStore.getSellerContactDescriptionText(),
      validationErrorReason: null,
      sellerContactDateError: false,
      descriptionTextError: false,
      descriptionTextValidationMessage:
        props.content.whenDidYouLastContactedTheSellerValidationMessage2,
      sellerContactDateValidationMessage:
        props.content.whenDidYouLastContactedTheSellerValidationMessage1,
    };
  }

  componentDidMount() {
    FraudAndDisputeStore.addChangeListener(this.onStoreChange);
  }

  componentWillUnmount() {
    FraudAndDisputeStore.removeChangeListener(this.onStoreChange);
  }

  onStoreChange = () => {
    const { setPage } = this.props;
    if (
      FraudAndDisputeStore.getShouldDisplayReviewScreen() &&
      moment(FraudAndDisputeStore.getSellerContactDate()).isValid() &&
      FraudAndDisputeStore.getSellerContactDescriptionText()?.length
    ) {
      setPage(PAGE_REVIEW_YOUR_DISPUTE);
      AnalyticsUtil.analyticAction(
        config.analytics.analytics_experience_activity,
        config.analytics.analytics_event_method_interacted,
        config.analytics
          .analytics_action_dispute_what_happened_when_contacted_the_seller,
        config.analytics.analytics_action_button_click
      );
      return;
    }
  };

  onContinueClick = () => {
    const { sellerContactDate, descriptionText } = this.state;
    const { content } = this.props;
    !sellerContactDate &&
      this.setState({
        sellerContactDateError: true,
        sellerContactDateValidationMessage:
          content.whenDidYouLastContactedTheSellerValidationMessage1,
      });
    (!descriptionText || (descriptionText && !descriptionText.trim().length)) &&
      this.setState({
        descriptionTextError: true,
        descriptionTextValidationMessage:
          content.whenDidYouLastContactedTheSellerValidationMessage2,
      });
    if (
      sellerContactDate &&
      sellerContactDate <= new Date() &&
      descriptionText &&
      descriptionText.trim().length &&
      descriptionText.length >= DESCRIPTION_TEXT_MINIMUM_CHARACTERS_LENGTH &&
      descriptionText.length <= DESCRIPTION_TEXT_MAXIMUM_CHARACTERS_LENGTH
    ) {
      this.setState({
        sellerContactDateError: false,
        descriptionTextError: false,
      });
      FraudAndDisputeActionCreator.setSellerContactDate(sellerContactDate);
      FraudAndDisputeActionCreator.setSellerContactDescriptionText(
        descriptionText
      );
      FraudAndDisputeActionCreator.displayReviewScreen(true);
      return;
    }
    if (
      descriptionText &&
      descriptionText.trim().length &&
      descriptionText.length >= DESCRIPTION_TEXT_MINIMUM_CHARACTERS_LENGTH &&
      descriptionText.length <= DESCRIPTION_TEXT_MAXIMUM_CHARACTERS_LENGTH
    ) {
      this.setState({
        descriptionTextError: false,
      });
    }
    if (
      descriptionText &&
      descriptionText.trim().length &&
      descriptionText.length < DESCRIPTION_TEXT_MINIMUM_CHARACTERS_LENGTH
    ) {
      this.setState({
        descriptionTextError: true,
        descriptionTextValidationMessage:
          content.goodsDescriptionTextValidationMessage2,
      });
    }
    if (
      descriptionText &&
      descriptionText.trim().length &&
      descriptionText.length > DESCRIPTION_TEXT_MAXIMUM_CHARACTERS_LENGTH
    ) {
      this.setState({
        descriptionTextError: true,
        descriptionTextValidationMessage:
          content.whenDidYouLastContactedTheSellerValidationMessage4,
      });
    }
    if (sellerContactDate && sellerContactDate <= new Date()) {
      this.setState({
        sellerContactDateError: false,
      });
    }
    if (sellerContactDate && sellerContactDate > new Date()) {
      this.setState({
        sellerContactDateError: true,
        sellerContactDateValidationMessage: content.enterCurrentDateOrEarlier,
      });
      return;
    }
  };
  render() {
    const { content, setPage } = this.props;
    const {
      sellerContactDate,
      descriptionText,
      sellerContactDateError,
      descriptionTextError,
      descriptionTextValidationMessage,
      sellerContactDateValidationMessage,
    } = this.state;
    return (
      <div>
        <ApplicationFormShell
          leftSidebar={
            <DisputeProgressComponent
              items={content.disputeProgressStepperItems}
              currentId="4"
            />
          }
        >
          <PageHeading>
            {content.whatHappenedWhenContactedTheSeller}
          </PageHeading>
          <StandardBody>
            <strong>{content.whatHappenedWhenContactedTheSellerSubText}</strong>
          </StandardBody>
          <div className="web-ui-components">
            <GenericFieldWrapper
              titleText={content.whenDidYouLastContactedTheSeller}
              validationMessage={
                sellerContactDateError && sellerContactDateValidationMessage
              }
            >
              {/* @todo - This should be replaced once the generic DD-MM-YYYY component is available in the web ui lib */}

              <DateOfBirthInput
                id="delivery-date"
                onChange={(obj) =>
                  this.setState({
                    sellerContactDate: obj.value,
                  })
                }
                value={sellerContactDate}
              />
            </GenericFieldWrapper>
            <GenericFieldWrapper
              titleText={content.describeYourContactWithSeller}
              validationMessage={
                descriptionTextError && descriptionTextValidationMessage
              }
            >
              <GenericTextArea
                id="seller-contact-description-text"
                characterWidth={40}
                hideCharacterCount
                onChange={({ value }) => {
                  this.setState({ descriptionText: value });
                }}
                value={descriptionText}
              />
            </GenericFieldWrapper>
          </div>
          <div className="button-group">
            <NavigationButton.Secondary
              labelText={content.back}
              onClick={() => {
                FraudAndDisputeActionCreator.displayReviewScreen(false);
                setPage(
                  FraudAndDisputeStore.getDisputeJourneyType() ===
                    content.goodsText
                    ? PAGE_DESCRIBE_THE_GOODS
                    : FraudAndDisputeStore.getDisputeJourneyType() ===
                      content.travelText
                    ? PAGE_DESCRIBE_THE_TRAVEL_BOOKING
                    : PAGE_DESCRIBE_THE_SERVICE
                );
              }}
            />
            <NavigationButton.Primary
              labelText={content.continueButtonText}
              onClick={this.onContinueClick}
            />
          </div>
        </ApplicationFormShell>
      </div>
    );
  }
}
